module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_number",
    attrs: {
      "id": "ch2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('h2', {
    staticClass: "sec_chapter"
  }, [_vm._v("Invasion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap2line"
  }, [_vm._v("I")]), _vm._v("n the early hours of 15 June, the French army began to cross the frontier; an army that was enthusiastic in its support of their ‘Great Captain’, who, like them, was confident of the expected outcome. The order of the day, issued on 14 June, proclaimed:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-1",
      "id": "ch02-fn_1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("Soldiers, today is the anniversary of Marengo and Friedland, places where the destiny of Europe was decided on two occasions. Accordingly, like after Austerlitz and Wagram, we believed the arguments and the oaths of the princes that we left on their thrones! Today, however, in their coalition against us they take offence at the independence and at the most sacred rights of France. They started their aggressions on a precise manner: let us therefore march to meet them; them and us, are we not the same men?")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Soldiers, at Jena, against those same Prussians, who are today so arrogant, you were one against three, and at Montmirail, one against six.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("That those of you who were prisoners of the English tell you their stories of their pontoons and of the horrible evils that they suffered.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The Saxons, the Belgians, the Hanoverians, the soldiers of the Rhine Confederation, groan at their obligations to help the cause of the princes who are enemies of the justice and the rights of all people. They know that this coalition is insatiable. After destroying twelve million Italians, one million Saxons, and six million Belgians, it will devour the smaller States of Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The fools! One moment of good fortune blinds them. The oppression and the humiliation of the French people are above their power! If they move into France, they will find their graves.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Soldiers! We have to make forced marches, give battles, take risks; but, with steadiness, victory will be ours: the rights, the honour and the welfare of our country will be retaken.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("For each Frenchmen who has the courage, the moment has come to win or to die!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Napoléon’s plans called for a concentric advance of three columns onto Charleroi. Reille’s 2nd Corps and d’Erlon’s 1st Corps formed the left wing of the army, and were to march from Solre-sur-Sambre, via Thuin, to Marchienne-au-Pont, a short distance outside of Charleroi. Pajol’s cavalry in the centre, supported by Domon’s cavalry, was to advance from Beaumont to Charleroi, with General Vandamme’s 3rd Corps to follow under the protective cavalry screen. At the rear were Lobau’s 6th Corps and the Imperial Guard. The right wing comprised General Gérard’s 4th Corps, protected by one of Milhaud’s cuirassier divisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoléon’s plan was that if the army left its positions at 3.00, some 60,000 men would be at Charleroi by midday. However, things went very wrong before the campaign really began, as at 7.00 General-of-Division de Ghaisnes, Comte de Bourmont, who commanded the 14th Infantry Division, along with his staff, deserted their posts and headed off to join the Prussians. No doubt this caused widespread alarm among the division. General Hulot was named the new divisional commander by General Gérard. This was the first of many desertions that would happen over the next few days. Sergeant-Major Sylvain Larreguy, of the 93rd Regiment of Line Infantry, relates:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-2",
      "id": "ch02-fn_2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("On 15 June … General de Bourmont deserted and went over to the enemy. He was able to shed light on our strengths and on the campaign plan. The indignation of the troops was high, and it will long echo in posterity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Just as the shock of the desertion of de Bourmont was sinking into the officers of 4th Corps, the aide-de-camp carrying Napoléon’s orders to General Vandamme had fallen from his horse and broken his leg, thus the orders were not delivered on time. Therefore, Vandamme had not broken camp until after 7.00, several hours later than had been accounted for in the meticulous timetable for the day."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-3",
      "id": "ch02-fn_3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("The avantgarde: Pajol")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Marshal Grouchy was clearly aware of the importance of sticking to Napoléon’s timetable as closely as possible. Early on the morning of 15 June he dictated his orders to General Pajol:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-4",
      "id": "ch02-fn_4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("Bossus-les-Ralcourt 15 June 1815")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("If you please, dear general, instruct your army corps to mount at two o’clock in the morning and to reunite with the cavalry division of General Domon, to whom I have passed orders to form the avantguarde for the army and head to Charleroi; the division of General Domon will be on the left, and the division of General Soult to be on the opposite flank.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Attached to this order is a copy of the movement orders. March with the three other cavalry corps which will be taking different routes, you are to act with General Vandamme.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("You will receive immediate orders ether from Vandamme or the emperor, who is marching with the rearguard.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("I desire you to go to Charleroi and to pass through Bossus, Henneux and Gares, or on the main road from Philippeville to Charleroi.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Be sure to keep in communication and report to me any news.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Receive my dear general, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The marshal commanding the cavalry")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("Comte de Grouchy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pajol left his positions around 3.00, and his troops marched, it seems, in three columns, all of which were destined to converge on Charleroi. Domon’s command was the western-most column, taking a direct route to Charleroi. Pajol, with Soult and Subervie taking the centre and eastern-most columns, took a less direct path. In essence, they would come against Charleroi in a pincer movement from the south and southeast. General Reille and 2nd Corps would, it was hoped, approach at the same time from the south-west.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1st Cavalry Corps—or at least elements of it—arrived at Ham-sur-Heure at approximately 6.00 on the morning of 15 June 1815. This small town was about one mile from Marbais. The town was essentially square in plan, with a central block of buildings, and an outer ring of buildings following the town’s quadrangular plan. According to the Prussian officer, Wagner, Domon’s cavalry brigade (4th, 9th and 12th Chasseurs à Cheval, belonging to 3rd Corps) made contact with the Prussian 11th Company of the 28th Infantry Regiment."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-5",
      "id": "ch02-fn_5"
    }
  }, [_vm._v("5")])]), _vm._v(" The Prussian infantry made a stiff resistance, but was forced to withdraw to Couillet."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-6",
      "id": "ch02-fn_6"
    }
  }, [_vm._v("6")])]), _vm._v(" General Domon comments that the attack was led by Squadron Commander Petit, of the 9th Chasseurs à Cheval, and made 300 prisoners."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-7",
      "id": "ch02-fn_7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Combat at Couillet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At approximately 8.30, General Pajol arrived at the outskirts of Couillet, which was defended by the Prussians. Couillet lies on the northern edge of the immense woods of the Prince de Liège, de la Fereye and de Hublembue. The village itself was entered on its southern side by the metalled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Chemin de Philippeville")]), _vm._v(" (Philippeville road), which ran approximately due south, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Chemin de Charleroi")]), _vm._v(" (Charleroi road), which ran south-east. Both of these roads, we assume, would have been utilised by Pajol and Vandamme. Two roads entered the village from the west and converged at the centre of the village. All four roads funnelled into a single road that ran north-west to Marcinelles and was bounded by hedges on each side. At the north-eastern edge of the town was a shallow ford across the River Sambre. A second ford could be found at Ecluse, a short distance to the north-east of the village.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, at Couillet, about a mile below Charleroi, Pajol fell on a company of the 3rd Battalion of the 28th Prussian Infantry Regiment and forced it to surrender."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-8",
      "id": "ch02-fn_8"
    }
  }, [_vm._v("8")])]), _vm._v(" Colonel Biot himself mentions that he encircled the Prussians at a farm off the main road, set back among fields. He brought up a howitzer and in result to a short bombardment, the Prussians surrendered."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-9",
      "id": "ch02-fn_9"
    }
  }, [_vm._v("9")])]), _vm._v(" A French general of the Imperial Headquarters states these troops, around three hundred men, were former Grand Duchy of Berg soldiers, which a French general demanded to return to French service."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-10",
      "id": "ch02-fn_10"
    }
  }, [_vm._v("10")])]), _vm._v(" This appears to be the same incident in which General Letort was killed at Gilly (as we shall see below), so the writer appears to be mistaken, but these troops had formerly been in French service. Elsewhere, the 4th Company of the 2nd Westphalian Landwehr Regiment was captured by the French."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-11",
      "id": "ch02-fn_11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Combat at Marcinelles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As Pajol was arriving at Couillet, Domon was arriving at Marcinelles. He was at Jamignon at 7.00, with the division of Pierre Soult marching via Bommeree. The attack here coincided with General Reille’s attack at Marchienne-au-Pont. The cannonade was heard by Colonel Biot, the senior aide-de-camp to General Pajol. The small village of Marcinelles consisted of three conjoined hamlets, the primary focus a roughly rectangular hamlet, orientated north-west to south-east, centred upon a church and its cemetery. It was entered on the south-east by three roads, the Charleroi road and two lesser parallel roads. Running approximately east-west was a long row of houses. From the north-west point of the village ran the road to Charleroi. According to the Prussian writer Wagner, the road from Marcinelles to Charleroi was defended by a 500 metre-long palisaded dyke and a covered bridge connecting the village to Charleroi. Hedges lined with Prussian sharpshooters bordered the dyke and road."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-12",
      "id": "ch02-fn_12"
    }
  }, [_vm._v("12")])]), _vm._v(" The road entered Charleroi past a square redoubt on the town’s south-eastern angle, and then turned north-west as the road passed through the outer circuit of defences. Control of this road controlled access to the town of Charleroi and its vital bridge. The French 4th and 9th Chasseurs à Cheval made a sortie and encountered the 5th Battalion of the Prussian 23rd Infantry Regiment. The Prussians were surrounded and forced to surrender, the 4th Chasseurs à Cheval lost one officer killed and two wounded. The French cavalry then captured the village, but was repulsed by sharpshooters that lined the hedgerows and field boundaries, as well as the gardens and some of the village houses."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-13",
      "id": "ch02-fn_13"
    }
  }, [_vm._v("13")])]), _vm._v(" Without infantry support, there was little Domon could do to push the Prussians from the village. His dismounted chasseurs with their short carbines were no match for the Prussian sharpshooters."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-14",
      "id": "ch02-fn_14"
    }
  }, [_vm._v("14")])]), _vm._v(" General Ameil and the 5th Hussars were sent in the direction of Couillet to search for a ford to cross the river and come behind the enemy. Not being able to take the town, according to Pajol, Domon, along with Subervie, withdrew to the head of the wood of Hublembue."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-15",
      "id": "ch02-fn_15"
    }
  }, [_vm._v("15")])]), _vm._v(" Around 10:00 Napoléon was at Jamignon."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-16",
      "id": "ch02-fn_16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Combat at Marchienne-au-Pont")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("General Reille’s 2nd Corps marched out at dawn and occupied Thuin, Lobbes and Montignies-le-Tilleul. In doing so they pushed back Prussian outposts. At Lobbes, the 1st Chasseurs à Cheval debouched and pushed the Prussian pickets from the 2nd Battalion 1st Westphalian Landwehr Regiment and the 6th Uhlans back. Elements of Bachelu’s division pushed the Prussians back through Lobbes, with the bulk of the division moving onwards to Maladrie and Thuin."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-17",
      "id": "ch02-fn_17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General Reille was marching to Marchienne-au-Pont. The town was a mile or so due west of Charleroi and was protected by a valuable bridge over the Sambre, but he did not reach it until 10.00. Bachelu was ordered to storm the town, parts of which were dominated by a monastery to gain possession of the bridge. This operation would take time, and Bachelu was not across the Sambre until, it seems, 13.00. At Marchienne-au-Pont was the 2nd Battalion of the 6th Prussian Infantry Regiment. The bridge was barricaded and supported by two artillery pieces."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-18",
      "id": "ch02-fn_18"
    }
  }, [_vm._v("18")])]), _vm._v(" The Prussians note that the French attacked three times to capture the town and seize the bridge, but eventually fell back to Dampremy, to the north-east, and over the Sambre. General Reille in his report dated 15 June at 21.00 at Gosselies to Marshal Soult, notes that the cavalry of generals Piré and Hubert, with the 1st Chasseurs à Cheval, charged the Prussian infantry with vigour and took 200 prisoners."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-19",
      "id": "ch02-fn_19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Vandamme’s troops delayed, and the Prussians putting up more resistance than Napoléon had anticipated at Marciennes and Marchienne-au-Pont, Napoléon was forced to improvise to maintain the momentum of his advance. The Imperial Guard, marching in front of 3rd and 6th Corps, was ordered to take the lead over 3rd Corps and to move by forced marches."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-20",
      "id": "ch02-fn_20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By this time, Napoléon was at Jamignon where an embarrassed Pajol informed him that he had failed to take Marcinelles and Couillet."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-21",
      "id": "ch02-fn_21"
    }
  }, [_vm._v("21")])]), _vm._v(" Pajol was ordered to renew the attack, supported by two batteries of horse artillery and the Young Guard. The Young Guard, or more likely only a single regiment of the Young Guard (perhaps the 3rd Voltigeurs who are recorded as having casualties at Charleroi)"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-22",
      "id": "ch02-fn_22"
    }
  }, [_vm._v("22")])]), _vm._v(", led by General La Bédoyère,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-23",
      "id": "ch02-fn_23"
    }
  }, [_vm._v("23")])]), _vm._v(" supported by the sailors of the Guard, advanced and drove off the Prussian sharpshooters."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-24",
      "id": "ch02-fn_24"
    }
  }, [_vm._v("24")])]), _vm._v(" As more of the Imperial Guard arrived it was not long before all of Marcinelles and Couillet were held by the French, along with the defensive dyke which, importantly, lead to the intact bridge over the Sambre."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-25",
      "id": "ch02-fn_25"
    }
  }, [_vm._v("25")])]), _vm._v(" The 3rd Battalion of the 28th Prussian Infantry Regiment withdrew to Chatellet, where Gérard’s 4th Corps found them, along with the 11th Company of the 1st Battalion of the 2nd Westphalian Landwehr Regiment."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-26",
      "id": "ch02-fn_26"
    }
  }, [_vm._v("26")])]), _vm._v(" Placed in the churchyard at Dampray was the 1st Battalion of the 2nd Westphalian Landwehr Regiment, supported by two guns. Both these bodies of Prussian troops had orders to retreat to Gilly."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-27",
      "id": "ch02-fn_27"
    }
  }, [_vm._v("27")])]), _vm._v(" Reille was at Jumet by 15.00 and he began his movement to Gosselies, advancing his cavalry to the left of the Monceaux Wood, through which his infantry marched.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("The capture of Charleroi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With Marcinelles captured and the vital roadway into Charleroi taken, it was only a matter of time before the Prussian garrison was overwhelmed and the town and its bridge captured by the French. With more and more French troops flooding the area, Prussian Major von Rohr, commander of Charleroi, deployed his beleaguered force from the 6th Prussian Infantry Regiment: the 1st Company was placed on the road leading to Marchienne-au-Pont; the 2nd Company was on the road leading to Marcinelles; the 3rd and 4th Companies were placed in the central square of the town. A jäger detachment was on the road leading to Marchienne-au-Pont."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-28",
      "id": "ch02-fn_28"
    }
  }, [_vm._v("28")])]), _vm._v(" The sailors and engineers of the Imperial Guard stormed the barricade at the end of the dyke from Marcinelles to Charleroi."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-29",
      "id": "ch02-fn_29"
    }
  }, [_vm._v("29")])]), _vm._v(" Renee Bourgeois, surgeon-major of the 12th Cuirassiers, writes the following about the incident:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-30",
      "id": "ch02-fn_30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("The light cavalry of the centre followed the movement of the 2nd Corps on the road to Charleroi, and sweeping away through several successive charges all that opposed them, repulsed the enemy with force onto the Sambre, behind which he hastened to take positions to dispute the passage.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("A serious fight ensued in front of Charleroi, and was maintained for some time with great vivacity. While many sharpshooters defended the approach of the bridge, the Prussians took care to make it impracticable, in order to evacuate the city, and their columns were formed on the river, they received the French by a brisk fire, which stopped the impetuosity of their march for a few moments, but they soon became renewed again with vigour and such fearlessness that the Prussians pressed so strongly, and shelled by our batteries, were compelled to abandon the bridge without being able to destroy all of it, they managed to cause some damage that was easily repairable. The sappers and the marines of the Guard thither and soon ironed out difficulties, and then the enemy hastily withdrew from the city, and reached the heights which border on the side of Brussels. Our cavalry pursued them very closely, and the army that made its way without experiencing other obstacles, immediately took possession of Charleroi.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Twenty-three year-old Captain Marie Denis Larabit, who had accompanied Napoléon to Elba, and who during the Hundred Days had served in the engineers of the Imperial Guard, wrote:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-31",
      "id": "ch02-fn_31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("He crossed the river at Marchienne and Charleroi. M. Larabit was sent with the engineers of the Imperial Guard to destroy any barriers that would prevent our easy passage through Charleroi. He had barely entered the city when he found himself in front of a Prussian post, which fired at him from almost point-blank range. Immediately the fighting started and the Prussians were chased from the city. The engineers took up positions at the other end of Charleroi. The emperor arrived: he ordered that we were to entrench and fortify the first houses. The army filed off and marched forward.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the removal of the barricade around midday, Pajol’s horsemen had clattered through the village pushing the Prussians back towards Gilly and Fleurus."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-32",
      "id": "ch02-fn_32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coming under increasing pressure, the Prussians began an orderly withdrawal, and by 11.00 the town was evacuated."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-33",
      "id": "ch02-fn_33"
    }
  }, [_vm._v("33")])]), _vm._v(" Major Pierre François Tissot, officer commanding the 92nd Regiment of Line Infantry, notes that Napoléon arrived at Charleroi at 11.00."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-34",
      "id": "ch02-fn_34"
    }
  }, [_vm._v("34")])]), _vm._v(" Four hours had been lost in Napoléon’s methodical timetable."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-35",
      "id": "ch02-fn_35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jean Baptiste Berton, commanding the 14th and 17th Dragoons under the orders of General Chastel, formed part of Excelmans’s reserve cavalry and writes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-36",
      "id": "ch02-fn_36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("The light cavalry division of General Domon strongly pursued the enemy to Charleroi; a square of Prussian infantry wanted to stop us short of that city, to give them time to cut the bridge over the Sambre they had not yet mined. Colonel Desmichels, head of the 4th Chasseurs à Cheval Regiment, supported by the 9th, attacked the square and made four to five hundred prisoners. The corps of light cavalry of General Pajol, composed of six regiments, followed this division to cross the bridge of Charleroi, and then it moved to the right after detaching General Clary, with the 1st Regiment of Hussars, to Gosselies, where he sabred a Prussian battalion and took its flag.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Captain Aubry, of the 12th Chasseurs à Cheval, recalls that:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-37",
      "id": "ch02-fn_37"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("We reached the environs of Charleroi, the 12th Chasseurs forming the extreme avantgarde. I, with my squadron, were the first to penetrate the town, we found a small number of the enemy. We had been accompanied by a company of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pontonniers")]), _vm._v(" who quickly reestablished the bridge over the Sambre. We then took prisoner a battalion of Prussian light infantry who formed part of the Prussian rearguard, and who had remained to destroy the bridge, the emperor was satisfied with our conduct.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aubry is one of two sources to tell us that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pontonniers")]), _vm._v(" repaired or established a bridge at Charleroi. If a second bridge was established it would have eased the bottleneck in getting troops across the river. The bridge at Charleroi was narrow, restricting the movements of soldiers north and west. Here in Charleroi, field hospitals were established, which, following the action at Gilly housed forty wounded soldiers, most of who were from the cavalry of the Guard."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-38",
      "id": "ch02-fn_38"
    }
  }, [_vm._v("38")])]), _vm._v(" Here, too, a huge quantity of stores was captured and distributed:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-39",
      "id": "ch02-fn_39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("24,000 rations of bread, of which 4,000 were issued to troops in the town;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("126 sacks of flour each weighing 190 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("livres")]), _vm._v(", sufficient for 800 rations over four days;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1,200 rations of oats;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1,600 rations of hay;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("2,000 rations of straw; and")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("200 head of cattle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Charleroi was to be garrisoned by elements of 6th Corps, and become a field hospital.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Ney’s dispositions")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Upon arriving at Charleroi, Pajol was ordered by the emperor to detach the 1st Hussars towards Gosselies. He was then instructed to advance with the remainder of 1st Cavalry Corps towards Gilly."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-40",
      "id": "ch02-fn_40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vanguard was led by the French 1st Hussars, which encountered Prussian cavalry and infantry as it headed off."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-41",
      "id": "ch02-fn_41"
    }
  }, [_vm._v("41")])]), _vm._v(" At the start of the Hundred Days, the ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hussard du Roi’")]), _vm._v(" the regiment’s royalist incarnation, had been ordered to join the army of the Duke of Berry. At Chateauneuf, Captain Morel mutinied and headed to Paris with two companies in the name of the emperor. In consequence, General Clary"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-42",
      "id": "ch02-fn_42"
    }
  }, [_vm._v("42")])]), _vm._v(" was appointed colonel in place of Oudinot, the son of Marshal Oudinot. An analysis of 200 men with the regiment on 1 June 1815 gives the average age as twenty-five years three months. The regiment was a mix of veterans taken into the regiment in 1814 to bulk out the conscripts from 1813 and 1814, as the best men from the hussars were passed to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Hussard du Roi")]), _vm._v("’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-43",
      "id": "ch02-fn_43"
    }
  }, [_vm._v("43")])]), _vm._v(" In October 1814, the bulk of the regiment’s clothing was described as needing to be replaced. This seems to have occurred, as on 10 October 1814 the depot held 521 metres of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bleu celeste")]), _vm._v(" wool cloth, which was almost entirely used up, assuming no more stocks were purchased over the following year, making new dolmans and pelisses."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-44",
      "id": "ch02-fn_44"
    }
  }, [_vm._v("44")])]), _vm._v(" A painting by Vernet of Colonel Clary commanding the regiment shows the regiment’s elite company wearing colpacks—these items certainly did not exist either in use or in the magazine—and also scarlet side stripes to their blue breeches, and other troopers wearing the shako "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rouleau")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leading echelons of Reille’s 2nd Corps, were also moving upon Gosselies, presumably to cut off the line of retreat of Ziethen’s troops along the Brussels road, and to effect the separation of the Prussians from Wellington’s army. d’Erlon’s 1st Corps received orders to follow and support Reille’s 2nd Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 16.00, Gosselies fell into French hands when the Prussian garrison retreated to Fleurus. Marshal Ney and General Lefèbvre-Desnoëttes pushed back a small Allied contingent out of Frasné and pursued it until just short of Quatre-Bras. Perponcher had taken up defensive positions. Not knowing the strength of the Allied forces here, Ney broke off the action and wrote the following dispatch to Marshal Soult:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-45",
      "id": "ch02-fn_45"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("Gosselies, 15 June 1815. Eleven o’clock in the evening")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("To His Excellency the marshal major-general,")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Monsieur marshal, I have the honour to inform you, Your Excellency, that in conforming to the orders of the emperor that I received, with the cavalry of General Piré and the infantry of General Bachelu, I was able to dislodge the enemy from Gosselies. The resistance of the enemy was quite obstinate, but after an exchange of between twenty-five to thirty cannon shots, they retired to Heppignies via Fleurus. I captured 500 to 600 Prussian soldiers from the corps of General Ziethen.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Here is the location of my troops:")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("General Lefèbvre-Desnoëttes with the lancers and chasseurs of the Guard at Frasné;")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("General Bachelu with the 5th Division at Mellet;")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("General Foy with the 9th Division at Gosselies;")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The light cavalry of General Piré at Heppignies.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("General d’Erlon is based with the majority of his corps around Jumet; unfortunately, I am not able to transmit to you, Your Excellency, in this letter any further details about these dispositions.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("I send with this letter a report by General Lefèbvre-Desnoëttes.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("Ney.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Grouchy at Gilly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Elsewhere, with the French across the River Sambre in ever increasing numbers, Pirch withdrew his troops from the line of the river and concentrated his troops at Gilly. The defending forces under General Pirch comprised:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-46",
      "id": "ch02-fn_46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1st and 2nd Battalions 28th Infantry Regiment (around 1,200 men);")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1st and 2nd Battalions 2nd Westphalian Landwehr Infantry Regiment (around 1,200 men);")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1st and 2nd Battalions 1st West Prussian Infantry Regiment (the 6th Infantry regiment) (around 1,200 men);")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 3rd Battalion was in reserve;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1st West Prussian Dragoons;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four squadrons of the 1st Regiment of Westphalian Landwehr Cavalry; and")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Foot Battery Number 3.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pirch had around ten thousand men at his disposal. He initially deployed four battalions of infantry in the village, supported by an artillery battery on his right. The road to Fleurus was barricaded. Skirmishers were placed in hedgerows and ditches and the cavalry was drawn up in reserve. The 2nd Westphalian Landwehr Regiment was deployed on either side of the road, supporting the artillery. The regimental history of the 6th Prussian Infantry Regiment describes the positions occupied by the Prussians as follows:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-47",
      "id": "ch02-fn_47"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("The fusilier battalion was deployed in a small copse at the forward slope of the heights of Gilly. Four cannon were placed on a mount to the right, with two cannon between this point and the cobbled road to Fleurus, and the remaining two cannon on the road facing towards the exit of Gilly. The battalion’s skirmishers were placed behind hedges between the cannon to protect them.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("The 28th Regiment stood astride the road leading to Lodelinsart, with the regiment’s two musketeer battalions placed 200 paces behind the front, in the second line. Communications with the 1st Brigade, deployed at Gosselies, could not be maintained as the village of Ransart was too far away from the positions of both brigades for either of them to occupy it. The right flank of the brigade was all the more exposed when the village was occupied by French light infantry. The road to Fleurus was blocked with an abatis.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The 2nd Westphalian Landwehr Regiment was deployed on either side of the road, supporting the artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sub-Lieutenant Charles Etienne Philippe Gerbet"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-48",
      "id": "ch02-fn_48"
    }
  }, [_vm._v("48")])]), _vm._v(" (37th Regiment of Line Infantry) notes that Vandamme arrived at Charleroi at 13.00, and as soon as he arrived he began crossing the river and debouched on to the plain overlooking the town."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-49",
      "id": "ch02-fn_49"
    }
  }, [_vm._v("49")])]), _vm._v(" Napoléon, however, incorrectly states that Vandamme arrived at Charleroi only some two hours later, around 15.00."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-50",
      "id": "ch02-fn_50"
    }
  }, [_vm._v("50")])]), _vm._v(" Marshal Grouchy himself notes Napoléon ordered Vandamme to speed up his rate of march, and confirms that the dragoons marched across low ground to enable them to attack the Prussian left without being observed."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-51",
      "id": "ch02-fn_51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The village comprised a long row of houses and, with the hedges swarming with sharpshooters; it was clearly not terrain for cavalry. Napoléon sent Vandamme’s infantry, Excelmans’s cavalry and, it appears, the Imperial Guard to the front. The first tentative moves occurred around 15.30. Napoléon, who arrived around half an hour later")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("(16.00),"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-52",
      "id": "ch02-fn_52"
    }
  }, [_vm._v("52")])]), _vm._v(" directed the action from the windmill at Cobreil, on a small hill some 500 metres south of the church at Gilly. Close by the mill was a house owned by a man called Lambert, the owner of a local mine."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-53",
      "id": "ch02-fn_53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Due to a village being entirely unsuitable for cavalry operations, General Ameil sent the 5th Hussars to reconnoitre, and, upon reaching the far end of the village, was met by a fusillade of Prussian musketry and artillery fire."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-54",
      "id": "ch02-fn_54"
    }
  }, [_vm._v("54")])]), _vm._v(" Grouchy, concluding that Pajol’s cavalry alone could not carry the position, ordered up infantry support. The engineers and marines of the Guard were ordered to attack."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-55",
      "id": "ch02-fn_55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At 15.30, Marshal Soult informed General Gérard of 4th Corps that the emperor had encountered enemy troops and his object was to attack the enemy at the head of the Lambusart Wood. As soon as Gérard had crossed the Sambre, he was to attack any enemy troops he encountered and was to send a report of his dispositions to Soult."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-56",
      "id": "ch02-fn_56"
    }
  }, [_vm._v("56")])]), _vm._v(" Captain Aubry, of the 12th Chasseurs à Cheval, notes that:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-57",
      "id": "ch02-fn_57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("In the evening, the emperor arrived, and was supported by a picket of grenadiers à cheval and they crushed many Prussian battalions; it was a good start.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Captain Coignet, attached to the Imperial Headquarters, confirms the presence of the picket of the grenadiers à cheval:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-58",
      "id": "ch02-fn_58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("In order to gain a footing in the plain of Fleurus, the emperor went on in advance, following the main road with his staff and a squadron of the horse grenadiers. He talked a while with his aide-de-camp. He looked over to his left, took his small glass, and examined attentively a perpendicular eminence far off from the road in an immense plain. He saw some dismounted cavalry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite Napoléon having arrived at 16.00, no attack was made for a further two hours, until 18.00. Why was there yet further delay? Neither of Napoléon’s wings were secure: on the right, Gérard and the 4th Corps were not yet across the Sambre (hence he was sent an order at 15.30 to urge him into action), while the left wing under d’Erlon was also slow. Reille was on the left with Ney, but until Napoléon knew that Gosselies was secure, he did not risk an attack in the centre not knowing where the Prussians were. If Napoléon attacked and pushed the Prussians back, and his flanks were open, Prussian troops could have separated him from Reille and 2nd Corps, perhaps leaving him isolated and cut off from the bulk of the French army, as Pierre de Witt makes clear:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-59",
      "id": "ch02-fn_59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("Seen in the context of the strategy of the central position, the left wing was, on 15 June, eventually to be in a position between Gosselies and Marchienne-au-Pont, while securing the road to Mons. At the same time, the left flank of this position was to be reconnoitred towards Mons, Nivelles, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Within this position, it becomes clear that the 2nd Corps, based at Gosselies had a prominent orientation and vigilance to the east towards the Prussian army, while the 1st Corps had one to the southwest, to a point where Wellington was expected to be concentrating.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("In time, the accent shifted that day from an orientation from Charleroi as a starting point to both north (Brussels road) and west (Mons road) in general, to Gosselies in particular. In this process, the forces put against Wellington’s army through Marchienne-au-Pont towards Mons were reduced in strength, while the measures securing the crossings of the Sambre further south were withdrawn.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("In looking at the orientation towards Mons and the concern for main passages over the Sambre, Napoléon clearly felt uneasy about a possible irruption of Wellington’s army over this river into the French rear on the operation line running back through Beaumont and Laon towards Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Battalion Commander Guillaume Baudus (aide-de-camp to Marshal Soult) suggests that the battle did not start early, simply because Napoléon was exhausted and had fallen asleep:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-60",
      "id": "ch02-fn_60"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("After passing the Sambre at Charleroi, Napoléon, wanting to see his troops defile past, climbed the hill overlooking the right bank of the river, and as the road is very narrow in the place where he stopped, he placed himself in the entrance of a large courtyard, and sent for a chair on which he settled, and soon fell deeply asleep. We can get a fair idea, having not seen, the enthusiasm of the soldiers passed him, and I cannot render the indignantly of which I was transported to when I saw that the cheers, the cries of joy, a noble and energetic translation of the infamous exclamation of Roman gladiators, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Morituri te salutamus, Cesar")]), _vm._v(", had no more power to get him out of his sleep than they had.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Napoléon disingenuously notes that Vandamme and Grouchy ‘wasted’ two hours, had been misled by false reports exaggerating the Prussian strength (200,000 men), that it was only through his personal intervention that the true strength of the Prussians was realised, and so he immediately ordered an attack."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-61",
      "id": "ch02-fn_61"
    }
  }, [_vm._v("61")])]), _vm._v(" This contradicts both Grouchy and his aide-de-camps, Bella and Baudus. Neither Coignet nor Aubry mention Grouchy accompanying Napoléon. Napoléon notes that Vandamme arrived at Charleroi at 15:00."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-62",
      "id": "ch02-fn_62"
    }
  }, [_vm._v("62")])]), _vm._v(" Grouchy further notes that when Vandamme arrived, he immediately attacked without orders and was repulsed. In this attack, in the 1st Brigade of the 8th Infantry Division (part of 3rd Corps), the 15th Regiment of Light Infantry had one officer wounded and one died of wounds that day. These are the only known casualties for all of the infantry of 3rd Corps for that day, without further archive research being undertaken. The Prussians notes the start of the action as follows:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-63",
      "id": "ch02-fn_63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("Right in front of our eyes the enemy cavalry corps of Pajol and Excelmans, with large numbers of infantry and artillery, crossed the Sambre for the attack. The artillery duel had already begun, as had a skirmish fight in which Major von Quadt had a horse shot from under him, when the order arrived to break off the battle and fall back on Fleurus. This order was made all the more difficult to carry out because the artillery limbered up and then withdrew immediately, leaving the first line of the infantry to withdraw across an open field in front of the French cavalry corps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The action began with the French directing the battle from the windmill near the farm of Grand Dieu. We are told that Napoléon in person, along with Marshal Grouchy, reconnoitred the enemy positions and judged that two divisions from General Ziethen’s command of around 15,000 to 18,000 men occupied the Lambusart Wood."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-64",
      "id": "ch02-fn_64"
    }
  }, [_vm._v("64")])]), _vm._v(" At this stage, it seems the French had moved up a horse artillery battery in support."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-65",
      "id": "ch02-fn_65"
    }
  }, [_vm._v("65")])]), _vm._v(" The battle commenced with a short barrage by sixteen guns from 3rd Corps, commanded by Colonel Dougerou."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-66",
      "id": "ch02-fn_66"
    }
  }, [_vm._v("66")])]), _vm._v(" Prussian General Pirch observed three dense infantry columns assaulting the heights. One went in the direction of the fusilier battalion of the 1st West Prussian Infantry Regiment which occupied the woods, the second attacked in the centre of the village of Gilly and the third in support. Initially the Prussian artillery fired back, but, outnumbered, their guns fell silent."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-67",
      "id": "ch02-fn_67"
    }
  }, [_vm._v("67")])]), _vm._v(" Napoléon proposed that Excelmans’s dragoons were to attack the Prussians in the flank after crossing the River Sambre at the mill of Delhatte, to the south-east."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-68",
      "id": "ch02-fn_68"
    }
  }, [_vm._v("68")])]), _vm._v(" The terrain prevented the Prussians observing this movement, so the dragoons fell on the Prussian left flank unopposed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General Berthezène recalls that Letort charged with no support from Excelmans:")]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("The impatience of the emperor, and perhaps also that of the troops of the service squadrons to attack Gilly, before they could be supported, either by infantry or by another corps of cavalry, passing in front of the hillock on which the enemy was, were ordered to take them in the rear. In this hasty attack, General Letort, adjutant of the emperor and who commanded the squadrons, was killed. He was an officer of great resolution. A few minutes later, the cavalry arrived, debouched and sabred the enemy, which was formed in hollow square, and, without waiting for our infantry to attack, they broke and fled into the woods, where the next morning many were made prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A clear narrative of events here is lacking from the eyewitness material. The charge of the Imperial Guard cavalry is absent from the narratives of Pajol, Excelmans and Grouchy in any clear detail. Grouchy suggests that the charge was initiated to extricate Vandamme’s infantry."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-70",
      "id": "ch02-fn_70"
    }
  }, [_vm._v("70")])]), _vm._v(" Gourgaud suggests that Napoléon became impatient with the lack of success and ordered what turned out to be a ‘death or glory charge’ for the Empress Dragoons."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-71",
      "id": "ch02-fn_71"
    }
  }, [_vm._v("71")])]), _vm._v(" Prussian writer Damitz tells us that the Guard dragoons charged after the dragoons of Burthe and Bonnemains had attacked and cut up the West Prussian dragoons."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-72",
      "id": "ch02-fn_72"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps we will never know the true turn of events. Gustave Pontécoulant, of the Imperial Guard horse artillery, tells us that after the dithering of Vandamme and Grouchy, Napoléon ordered the duty squadron to charge to break the then impasse between the French and Prussians. He writes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-73",
      "id": "ch02-fn_73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("The infantry of the 3rd Corps, formed in column, was to march directly on Gilly, while General Excelmans, with his cavalry, was to pass on the right that crosses the creek, to flank to the Prussians, and advance to the defile of the Lambusart Wood and they were obliged to traverse to retire on Fleurus. These provisions were a great success: General Ziethen, who soon realised he would be crushed, hastened to evacuate Gilly, and took a position back and forth between this village and that of Fleurus, his back against a wood.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("The emperor had given the movement orders to march forward and to dislodge him, but this order was feebly executed, General Vandamme and Grouchy, deceived by false reports, had imagined that the entire Prussian army, with more than 100,000 men, was waiting at the entrance of the woods, in order of battle on the plain of Fleurus; they had lost two hours of unnecessary trial and error, and advanced with extreme reluctance. Napoléon, who meanwhile had dismounted and was talking on the edge of the Lambusart Wood with some officers of his staff, impatient because of all these delays, and to see before him escape a Prussian corps when a little more daring and activity could have taken them, mounted his horse to go himself to reconnoitre the enemy, believing that the woods were only occupied by two divisions of Ziethen’s corps that had moved from Charleroi, forming eighteen or twenty thousand men at most, he gave new orders to march forward to force the issue.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pontécoulant then narrates that Napoléon ordered forward the four duty squadrons of the Imperial Guard, headed by General Letort."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-74",
      "id": "ch02-fn_74"
    }
  }, [_vm._v("74")])]), _vm._v(" Both French and Prussian sources say that Letort led forward the duty squadron, which comprised on that day of a squadron each from the grenadiers à cheval, Empress Dragoons, chasseurs à cheval and the lancers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the immediate picket to Napoléon on 15 June was, according to Aubry and Coignet (both independent writers), composed of the grenadiers à cheval and not the Empress Dragoons. If Letort was ordered to lead forward the duty squadron in the manner described by Pontécoulant and other French writers, then the body of cavalry immediately to hand was the grenadiers à cheval. Analysis of the casualty returns for the grenadiers à cheval compared to the Empress Dragoons shows that the grenadiers à cheval lost men from all four squadrons."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-75",
      "id": "ch02-fn_75"
    }
  }, [_vm._v("75")])]), _vm._v(" In comparison, the Empress Dragoons suffered a single trooper killed compared to the five killed, eleven wounded and twenty horses lost for the grenadiers à cheval."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-76",
      "id": "ch02-fn_76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As well as the Guard cavalry duty squadrons, here at Gilly was a large concentration of French cavalry under Excelmans: General Stoltz’s"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-77",
      "id": "ch02-fn_77"
    }
  }, [_vm._v("77")])]), _vm._v(" division, comprising General Burthe’s"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-78",
      "id": "ch02-fn_78"
    }
  }, [_vm._v("78")])]), _vm._v(" brigade (5th Dragoons and the 13th Dragoons, totalling perhaps 930 men) and General Vincent’s"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-79",
      "id": "ch02-fn_79"
    }
  }, [_vm._v("79")])]), _vm._v(" brigade (15th and 20th Dragoons, mustering some 1,431 men). We are told that three squadrons of the 20th Dragoons were in action by Napoléon’s bulletin. It also seems that General Chastel’s command was in action. The 1st Brigade, lead by General Bonnemains"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-80",
      "id": "ch02-fn_80"
    }
  }, [_vm._v("80")])]), _vm._v(" (comprising of the 4th and 12th Dragoons), also took part in the attack."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-81",
      "id": "ch02-fn_81"
    }
  }, [_vm._v("81")])]), _vm._v(" Bonnemains does not mention the 15th or 20th Dragoons and says that his command alone supported the duty squadrons."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-82",
      "id": "ch02-fn_82"
    }
  }, [_vm._v("82")])]), _vm._v(" Given that it seems that the Empress Dragoons charged with three squadrons of the 20th Dragoons and a squadron of the 15th Dragoons, it is not impossible that the 4th and 12th Dragoons, supported the duty squadron, and that the grenadiers à cheval attacked without support. The 15th Dragoons were in action that day, as Captain Antoine Lucien Deligny, Sub-Lieutenant Jean Gabriel Borde and Sub-Lieutenant Jean Baptist Louis Mony were all wounded. As they were all from the same squadron, this confirms Berton’s claim that only a single squadron was in action from 15 June."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-83",
      "id": "ch02-fn_83"
    }
  }, [_vm._v("83")])]), _vm._v(" The 20th Dragoons recorded no officers dead or wounded. For whatever reason, Excelmans, in his report of 16 June, only mentions the 15th and 20th Dragoons and denies he suffered any casualties, which we know to be a lie."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-84",
      "id": "ch02-fn_84"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General Berton was a fascinating individual, one who would ultimately pay the price for his ardent Bonapartism when he was executed by the state in 1822."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-85",
      "id": "ch02-fn_85"
    }
  }, [_vm._v("85")])]), _vm._v(" He commanded the 2nd Brigade, comprising the 14th and 17th Dragoons, and seems to have been involved at some point."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-86",
      "id": "ch02-fn_86"
    }
  }, [_vm._v("86")])]), _vm._v(" To this were added the 4th and 9th Chasseurs à Cheval from Pajol, as well as the grenadiers à cheval and Empress Dragoons of the Imperial Guard. Captain Jean Roche Coignet, serving on Napoléon’s staff as baggage-master, witnessed, it seems, a charge conducted by cuirassiers:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-87",
      "id": "ch02-fn_87"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("It was, I believe, on the 14th that we met a large body of the Prussian advance-guard beyond Gilly. The cuirassiers went through the town at such speed that the horses’ shoes flew over the houses. The emperor watched them go through before leaving. It was a steep ascent, but it was impossible to imagine the rapidity with which that body of cavalry could go over a mountain. Our intrepid cuirassiers fell upon the Prussians, and sabred them without taking any prisoners. They were driven back upon their front with considerable loss. The campaign had begun.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Were these Delort’s men? Or has Coignet mistaken the body of cavalry, as he notes the attack at Gilly was on 14 and not 15 June? If Coignet is wrong about the date, is he also wrong about what he observed? Colonel Biot notes that once Gilly had been stormed the cavalry debouched along the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("faubourg")]), _vm._v(" in the direction of Lodelinsart."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-88",
      "id": "ch02-fn_88"
    }
  }, [_vm._v("88")])]), _vm._v(" In the pursuit, General Stroltz’s dragoons ran into the Prussian dragoons of Moisky at Chatelineau, and pursued them through the Pironchamp Wood to the edge of the Lambusart Wood."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-89",
      "id": "ch02-fn_89"
    }
  }, [_vm._v("89")])]), _vm._v(" Grouchy had initiated a skilful cavalry pursuit that was stopped by Ziethen’s reserves. Grouchy himself notes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-90",
      "id": "ch02-fn_90"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("Village de Campimarie, the 15th, ten o’clock in the evening")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Sire,")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("I have the honour to report to Your Majesty that the corps of General Excelmans aimed to overwhelm the position occupied by the enemy beyond the village of Gilly. He crossed the ravine which separated us and charged onto the plain above Chatelineau; he has not pushed up beyond Ronchamps, and having repulsed their cavalry, fell onto squares of infantry, they were crushed and he made over 400 prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The enemy, trying to hold the wood, sought to seek protection from the fire of his infantry, several companies of dragoons were dismounted and opened fire on the Prussian infantry which gave time for the infantry of General Vandamme to arrive. The march on the road through the woods was again supported by dragoons who continued to pursue the Prussians to the village of Lambusart, which General Chaste"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-91",
      "id": "ch02-fn_91"
    }
  }, [_vm._v("91")])]), _vm._v(" is still hunting. It is impossible to show greater intrepidness than that by the corps of General Excelmans, including the brigade of General Vincent, composed of the 15th and 20th regiments of Dragoons. Squadron Leader Guibourg, of 15th Regiment, destroyed a square and made 300 prisoners. I recommend him to Your Majesty’s kindnesses.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Summarily, Pajol, at the head of the 1st Corps, drove the enemy from the direct route of Gilly to Fleurus, he made several hundred prisoners and was no less distinguished than General Excelmans, and I cannot do enough to praise him to Your Majesty. He is constantly shouting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Vive l’Empereur’")]), _vm._v(" and with an enthusiasm difficult to describe. His men have everywhere addressed the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Please accept my sincerest regards sire,")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("Marshal Comte de Grouchy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grouchy here talks extensively about the operations of Excelmans, perhaps as he had not received that of Pajol. About the day’s action, General Excelmans writes to Grouchy as follows:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-92",
      "id": "ch02-fn_92"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("I have the honour to inform Your Excellency that in the battle which took place yesterday, under your eyes, the brigade of General Vincent had two officers wounded, and with twenty-seven dragoons killed. This brigade has done his duty perfectly. They were led by the brave General Vincent who has extensive experience, showed great firmness and has the rarest of composure, I beg Your Excellency to request him to the emperor to be promoted a grade more in the Legion of Honour.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Colonel Bricqueville"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-93",
      "id": "ch02-fn_93"
    }
  }, [_vm._v("93")])]), _vm._v(" (20th) was of good conduct and also Squadron Commander Guibourg"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-94",
      "id": "ch02-fn_94"
    }
  }, [_vm._v("94")])]), _vm._v(" (the 15th) who led the 1st Squadron, as this officer is very old, I ask for him the rank of major.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The following men designated are those who have distinguished themselves in the affair of yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("20th Dragoons, MM. Captains Marguiennes and Ramorette. Lieutenant Jory, Adjutant-Sub-Officer Barie, Sub-Lieutenant Warin, Sergeant-Majors Marcey (injured) and lley, and Grenadier Pisse, who made twenty-seven of the enemy prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("In my staff, Colonel Ferroussat"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-95",
      "id": "ch02-fn_95"
    }
  }, [_vm._v("95")])]), _vm._v(" behaved at his best: the officer is fit to command a regiment. Squadron Commander Sensier, my aidede-camp, also behaved with great bravery. Captain Franchen, attached to my small staff, acted with great daring: I ask for him the rank of battalion commander.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("I ask the Cross of the Legion of Honour to M. Dibon,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-96",
      "id": "ch02-fn_96"
    }
  }, [_vm._v("96")])]), _vm._v(" my aidede-camp, to M. Gemarmon, First Lieutenant of chasseurs, who behaved well. The latter is quite dangerously wounded; he was attached to my staff.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("I have the honour, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("However, General Pajol writes at 22.00 on 15 June to Marshal Grouchy that:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-97",
      "id": "ch02-fn_97"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("I would have occupied the village if General Vandamme had sent me some infantry support, but it seems that this general has taken to endeavour to do everything that is against the principles of war, because he failed to occupy the Lambusart Wood at Gilly and Fleurus, which are the two main points in the position where we are.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("My troops have been perfectly conducted today. I seized Charleroi, I was the first to pass the Sambre, and with no support, for four hours I resisted all the efforts of the enemy, which must earn those who have distinguished themselves the kindness of His Majesty. I have the honour of addressing you tomorrow their names. I am, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pajol’s inference is that between 12.00 and around 16.00, he kept at bay Prussian skirmishers between Charleroi and Gilly. This long, drawn out skirmish to control the road may well explain the time it took for the French to get to Gilly. This delaying action on the part of the Prussians, however, enabled sufficient time for Vandamme to arrive. However, Vandamme seems to have been unaware of who his direct field commander was, or perhaps, was being bellicose and belligerent in not wanting to support Grouchy’s attack. General Sénécal, aide-de-camp to Marshal Grouchy, writes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-98",
      "id": "ch02-fn_98"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("15 June, at the allotted time Marshal Grouchy crossed Charleroi, followed by a portion of the light cavalry of General Pajol. We were not to a quarter of a league from that town when we discovered the Prussian corps of General Ziethen in battle order on the other side of a deep valley, where a stream flows, and he crowned the heights that dominated it.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The marshal sent me to inform the emperor, and, after reviewing with him the position of the enemy, ordered them to be attacked as soon as the dragoons of General Excelmans, who were still behind, had arrived. The attack took place as soon as they had joined. The Prussians were driven back and were pursued through the woods until near Fleurus, where he could not have captured the place having no infantry support. The marshal sent to General Vandamme, who had arrived with his corps to Lizière Wood on the hills that dominated Fleurus, the orders to hasten into the city and to use the little daylight left to attack in concert with him the Prussians, and pursue them to Fleurus, and complete the rout.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("General Vandamme refused and marshal sent one of his officers to the emperor, to prevent and complain about it.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("The emperor, who had remained at Charleroi, replied that the strictest orders were given to the generals commanding the infantry corps, that they might not escape the execution of the orders of the marshal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clearly there was some ill-feeling between Vandamme and Grouchy. We are told by Baron Gourgaud that Grouchy asked in person for infantry support and was rebuffed by Vandamme. He then sent General Excelmans on the same mission, who told the general that it was important that he released some of his infantry support to Grouchy. Gourgaud says he sent only a single battalion."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-99",
      "id": "ch02-fn_99"
    }
  }, [_vm._v("99")])]), _vm._v(" How reliable this narration of events is we can only judge against the words of Grouchy; Pajol, Excelmans and Vandamme are silent about this episode.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the infighting between Grouchy and Vandamme, the action at Gilly had been a success. The personality clashes between Grouchy and his subordinates were to have an impact on the days ahead. Napoléon claims that the army captured five Prussian artillery pieces:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-100",
      "id": "ch02-fn_100"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqnt"
  }, [_vm._v("At three hours after midday, General Vandamme debouched with his corps on Gilly.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("Marshal Grouchy arrived with General Excelmans’s cavalry.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("The enemy occupied the left of the position of Fleurus. At five hours after midday, the emperor ordered the attack. The position was turned and carried. The four duty squadrons of the Guard, commanded by General Letort, aide-de-camp of the emperor, forced three squares: the 26th, 27th and 28th Prussian regiments were put to rout. Our squadrons sabred 400 to 500 men and took 1,500 prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("During this time, General Reille passed Sambre at Marchienne-au-Pont, to move on Gosselies with the divisions of Prince Jérôme and of General Bachelu, the enemy attacked, he took 250 prisoners and continued on the road to Brussels.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("We thus became masters of all the position of Fleurus.")]), _vm._v(" "), _c('p', {
    staticClass: "bqni"
  }, [_vm._v("At eight o’clock in the evening, the emperor returned to his Charleroi headquarters.")]), _vm._v(" "), _c('p', {
    staticClass: "bqnib"
  }, [_vm._v("This day cost the enemy five artillery pieces and 2,000 men, including 1,000 prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But, Napoléon, in a letter to his brother dated 15 June (timed at 21.00), notes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-101",
      "id": "ch02-fn_101"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("The army has forced the Sambre close to Charleroi and pushed the advanced guard’s halfway from Charleroi to Namur and from Charleroi to Brussels. We took 1,500 prisoners and captured six pieces of artillery. Four Prussian regiments were crushed. The emperor lost little, but he had a loss which is very sensitive for him: it is his aide-de-camp, General Letort, who was killed on the Fleurus plateau leading a charge of cavalry. The enthusiasm of the inhabitants of Charleroi and all the countries which we cross cannot be described.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clearly, either the Prussians are mistaken that the Prussian artillery withdrew or Napoléon was exaggerating his success of the day. We note he is inconsistent with the number of artillery pieces captured. Therefore, we cannot take at face value these two statements made by Napoléon: they contradict each other and in places are incorrect. He also, it seems, played down the strength of the French force engaged against Pirch. He honours the 20th Dragoons and the duty squadron, but fails to mention the grenadiers à cheval, the Young Guard, the Old Guard and the 15th Regiment of Light Infantry. Thus, Napoléon’s firsthand testimony of the day cannot be relied upon as an accurate statement of events.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Tactical summary")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Napoléon’s plan for the day had been to keep the two Allied armies from uniting—this he had achieved, but in doing so had divided his own forces. This turned out to be a major tactical mistake by the emperor in hindsight. Despite success, the emperor’s carefully planned timetable was in shreds. When the French came against Charleroi on the morning of 15 June, no immediate assault began until 8.00, simply because Vandamme was not where he was supposed to have been.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gilly was an important position for the Prussians. It had to be maintained to keep the line of retreat open to Sombreffe. Holding the positions also allowed the Allies to assess where exactly Napoléon was. Perhaps, if Grouchy had been supported at Fleurus on 15 June, the Prussians would not have been able to concentrate at Sombreffe, and would have split both the Prussian forces in two, but also separated the British and their allies from the Prussians."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-102",
      "id": "ch02-fn_102"
    }
  }, [_vm._v("102")])]), _vm._v(" Clausewitz notes:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-103",
      "id": "ch02-fn_103"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("Since the enemy had already begun attacking at four o’clock in the morning and had therefore spent the night and the whole previous day on the move and in combat, it was pretty clear that he would neither undertake anything further during the night, nor even resume his attack very early the next day. It could thus be foreseen that if a battle was going to take place at Sombreffe on the 16th, it could begin only in the afternoon, so the armies would have until midday to assemble. General Ziethen’s losses on the 15th are given as 1,200 men, but they may have been as high as 2,000. With this sacrifice, the 1st Corps had delayed the enemy’s army for thirty-six hours, which is no unfavourable result.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The regimental history of the 6th Prussian Infantry Regiment narrates that:"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-104",
      "id": "ch02-fn_104"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "bqntb"
  }, [_vm._v("The brigade had moved through the Lambusart Wood and deployed in front of the village. Shortly beyond the edge of the wood was a path to the Sambre valley. Here, General von Pirch had placed Major von Rohr with the 1st Battalion to cover the flank of the retreat. The 2nd Battalion replaced the fusiliers, forming the rearguard of the brigade. The entire regiment was deployed directly behind the wood. The enemy, meeting such determined resistance, did not stop attempting to pursue, but had to wait for substantial reinforcements of infantry which gave the regiment time to fall back slowly to positions at Lambusart, threatened only by cavalry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The 6th Prussian Infantry Regiment arrived at Ligny at 23.30 that night."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn-105",
      "id": "ch02-fn_105"
    }
  }, [_vm._v("105")])]), _vm._v(" The large losses sustained by the Guard cavalry show that this engagement was more serious than has been implied by most writers on the campaign. Napoléon himself suggests that the battle was of little or no significance, and that the duty squadrons easily overran the Prussians. Clearly this does not seem to be the case. The Prussians held out for as long as they could against superior numbers. The attack at Gilly was one part of a string of attacks along a wide front to prevent the French from advancing into Brussels and, by holding the French troops up, bought the Allies time to start concentrating their troops for a larger engagement on the following day.")]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("The long, drawn out rearguard from Gilly to Fleurus bought the Prussians time to concentrate at Sombreffe; their chosen location for an engagement with the French.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section1"
  }, [_vm._v("NOTES:")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_1",
      "id": "ch02-fn-1"
    }
  }, [_vm._v("1")])]), _vm._v(" SHDDT: C15 5 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Correspondence Armée du Nord 11 Juin au 21 Juin 1815")]), _vm._v(". Dossier 15 June.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_2",
      "id": "ch02-fn-2"
    }
  }, [_vm._v("2")])]), _vm._v(" Silvain Larreguy de Civrieux, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs d’un cadet, 1813-1823")]), _vm._v(", Hachette, Paris, 1912.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_3",
      "id": "ch02-fn-3"
    }
  }, [_vm._v("3")])]), _vm._v(" E. F. Janin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Campagne de Waterloo")]), _vm._v(", Chaumerot Jeune, Paris, 1820, pp. 6-7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_4",
      "id": "ch02-fn-4"
    }
  }, [_vm._v("4")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June 1815. Grouchy to Pajol.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_5",
      "id": "ch02-fn-5"
    }
  }, [_vm._v("5")])]), _vm._v(" August Wagner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Plane der Schlachten und Treffen, welche von der Preussischen Armee in den Feldzügen der Jahre 1813, 14 und 15 geliefert worden")]), _vm._v(", Reimer, Berlin, 1825, p. 13. See also: Karl von Damitz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des Feldzuges von 1815 in den Niederlanden und Frankreich")]), _vm._v(", E. S. Mittler, Berlin, 1838, p. 69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_6",
      "id": "ch02-fn-6"
    }
  }, [_vm._v("6")])]), _vm._v(" Wilhelm Neff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des Infanterie-Regiments von Goeben (2. Rheinischen) Nr. 28")]), _vm._v(", Ernst Siegfried Mittler und Sohn, Berlin, 1890, p. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_7",
      "id": "ch02-fn-7"
    }
  }, [_vm._v("7")])]), _vm._v(" SHDDT: Xc 192 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("4e Chasseurs à Cheval")]), _vm._v(". Dossier 1815. Domon to Minister of War, 6 July 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_8",
      "id": "ch02-fn-8"
    }
  }, [_vm._v("8")])]), _vm._v(" Maurice Fleury, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs anecdotiques et militaires du colonel Biot")]), _vm._v(", Henri Vivien, Paris, 1901, p. 235. See also: William Siborne, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Waterloo Campaign 1815")]), _vm._v(", A. Constable, 1900, p. 103.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_9",
      "id": "ch02-fn-9"
    }
  }, [_vm._v("9")])]), _vm._v(" Fleury, p. 235.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_10",
      "id": "ch02-fn-10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouvel Revue Rétrospective")]), _vm._v(", January 1896, p. 362.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_11",
      "id": "ch02-fn-11"
    }
  }, [_vm._v("11")])]), _vm._v(" Emile von Conrady, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des Könglich preussischen sechsten Infaterie-regiments,")]), _vm._v(" Glogau, 1857, p. 240.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_12",
      "id": "ch02-fn-12"
    }
  }, [_vm._v("12")])]), _vm._v(" Wagner, p. 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_13",
      "id": "ch02-fn-13"
    }
  }, [_vm._v("13")])]), _vm._v(" Fleury, Vol. 3, p. 191.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_14",
      "id": "ch02-fn-14"
    }
  }, [_vm._v("14")])]), _vm._v(" Fleury, ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_15",
      "id": "ch02-fn-15"
    }
  }, [_vm._v("15")])]), _vm._v(" Fleury, Vol. 3, pp. 191-2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_16",
      "id": "ch02-fn-16"
    }
  }, [_vm._v("16")])]), _vm._v(" SHDDT: C15 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Registre d’ordre et de correspondance du major-general à partir du 13 Juin jusqu’au 26 Juin au Maréchal Grouchy")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_17",
      "id": "ch02-fn-17"
    }
  }, [_vm._v("17")])]), _vm._v(" SHDDT: C15 22 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Registre correspondence 2e corps observation Armée du Nord,")]), _vm._v(" p. 27. After-action report of 15 June 1815, timed at 21.00. Reille to Soult.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_18",
      "id": "ch02-fn-18"
    }
  }, [_vm._v("18")])]), _vm._v(" Toussaint-Jean Trefcon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carnet de la campagne du colonel Trefcon, 1793-1815")]), _vm._v(", E. Dubois, Paris, 1914, p. 179.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_19",
      "id": "ch02-fn-19"
    }
  }, [_vm._v("19")])]), _vm._v(" SHDDT: C15 5. Dossier 18 June 1815. Reille to Soult, 15 June 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_20",
      "id": "ch02-fn-20"
    }
  }, [_vm._v("20")])]), _vm._v(" Hippolyte de Mauduit, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Les derniers jours de la Grande Armée")]), _vm._v(" (Vol. 2), Paris, 1848, p. 11. See also, Gaspard Gourgaud, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La campagne de 1815,")]), _vm._v(" P. Mongie, Paris, 1818, p. 45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_21",
      "id": "ch02-fn-21"
    }
  }, [_vm._v("21")])]), _vm._v(" Fleury, Vol. 3, p. 192.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_22",
      "id": "ch02-fn-22"
    }
  }, [_vm._v("22")])]), _vm._v(" Compiled from SHDDT: GR 20 YC 55. See also: SHDDT: GR 20 YC 56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_23",
      "id": "ch02-fn-23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revue de l’Empire,")]), _vm._v(" 1842.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_24",
      "id": "ch02-fn-24"
    }
  }, [_vm._v("24")])]), _vm._v(" Fleury, p. 236.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_25",
      "id": "ch02-fn-25"
    }
  }, [_vm._v("25")])]), _vm._v(" Wagner, p. 14. See also: Damitz, Vol. 1, pp. 69-70, and Karl Rudolf von Ollech, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geschichte des feldzuges von 1815 nach archivalischen quellen")]), _vm._v(", E. S. Mittler und Sohn, Berlin, 1876, p. 103.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_26",
      "id": "ch02-fn-26"
    }
  }, [_vm._v("26")])]), _vm._v(" Wagner, p. 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_27",
      "id": "ch02-fn-27"
    }
  }, [_vm._v("27")])]), _vm._v(" Siborne, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Waterloo Campaign")]), _vm._v(", p. 103.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_28",
      "id": "ch02-fn-28"
    }
  }, [_vm._v("28")])]), _vm._v(" Conrady, p. 240.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_29",
      "id": "ch02-fn-29"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carnet de la Sabretache")]), _vm._v(", 1899, p. 243.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_30",
      "id": "ch02-fn-30"
    }
  }, [_vm._v("30")])]), _vm._v(" François-Thomas Delbare, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation circonstanciée de la dernière campagne de Buonaparte, terminée par le bataille de Mont-Saint-Jean, dite de Waterloo ou de la Belle-Alliance")]), _vm._v(", J. G. Dentu, Paris, 1816, p. 30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_31",
      "id": "ch02-fn-31"
    }
  }, [_vm._v("31")])]), _vm._v(" Germain Sarrut, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biographie des Hommes du Jour, etc")]), _vm._v(", Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_32",
      "id": "ch02-fn-32"
    }
  }, [_vm._v("32")])]), _vm._v(" Wagner, pp. 14-15. See also: Damitz, Vol. 1, p. 83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_33",
      "id": "ch02-fn-33"
    }
  }, [_vm._v("33")])]), _vm._v(" Wagner, p. 14. See also: Damitz, Vol. 1, pp. 69-70, and Ollech, p. 103.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_34",
      "id": "ch02-fn-34"
    }
  }, [_vm._v("34")])]), _vm._v(" Pierre François Tissot, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Histoire de Napoléon, rédigée d’après les papiers d’État, les documents officiels, les mémoires et les notes secrètes de ses contemporains, suivie d’un précis sur la famille Bonaparte")]), _vm._v(" (Vol. 2), Delange-Taffin, Paris, 1833, pp. 263-4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_35",
      "id": "ch02-fn-35"
    }
  }, [_vm._v("35")])]), _vm._v(" Fleury, p. 236. See also: Damitz, Vol. 1, p. 83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_36",
      "id": "ch02-fn-36"
    }
  }, [_vm._v("36")])]), _vm._v(" Jean Baptiste Berton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Précis historique, militaire et critique des batailles de Fleurus et de Waterloo, dans la campagne de Flandres, en juin 1815")]), _vm._v(", J. S. Wallez, La Haye, 1818, p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_37",
      "id": "ch02-fn-37"
    }
  }, [_vm._v("37")])]), _vm._v(" Thomas Joseph Aubry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mémoires d’un capitaine de chasseurs à cheval")]), _vm._v(", Jourdan, Paris, 2011, p. 150.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_38",
      "id": "ch02-fn-38"
    }
  }, [_vm._v("38")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June 1815. Daure to Soult.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_39",
      "id": "ch02-fn-39"
    }
  }, [_vm._v("39")])]), _vm._v(" ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_40",
      "id": "ch02-fn-40"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouvel Revue Rétrospective")]), _vm._v(", January 1896, p. 362.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_41",
      "id": "ch02-fn-41"
    }
  }, [_vm._v("41")])]), _vm._v(" Fleury, p. 237.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_42",
      "id": "ch02-fn-42"
    }
  }, [_vm._v("42")])]), _vm._v(" AN: LH 542/61. François Joseph Marie, Comte Clary, was born at Marseille on 3 October 1786. He was admitted to the 9th Dragoons on 8 February 1803 as a volunteer and was quickly rewarded by being made sub-lieutenant of the 22nd Dragoons on 7 December 1803. He is listed as a lieutenant in the 10th Dragoons on 3 May 1805 and was made aidede-camp to Joseph Bonaparte on 17 January 1806, before being named as colonel of the voltigeurs of the Royal Spanish Guard on 10 January 1810. He became the aide-de-camp to Marshal Berthier on 22 April 1813 and then colonel of the 1st Hussars on 27 June 1813, aged twenty-seven with ten years’ service. He was promoted to marshal-du-camp on 23 August 1814 and was placed on the non-active list. He is listed again as colonel of the 4th Chasseurs à Cheval on 26 March 1815, and took command of the 1st Hussars again on the 30 March. Following Waterloo, he was placed on half-pay.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_43",
      "id": "ch02-fn-43"
    }
  }, [_vm._v("43")])]), _vm._v(" SHDDT: Xc 238 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1e Hussard")]), _vm._v(". Dossier 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_44",
      "id": "ch02-fn-44"
    }
  }, [_vm._v("44")])]), _vm._v(" ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_45",
      "id": "ch02-fn-45"
    }
  }, [_vm._v("45")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June 1815. Ney to Soult, timed at 23.00.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_46",
      "id": "ch02-fn-46"
    }
  }, [_vm._v("46")])]), _vm._v(" Wagner, pp. 17-20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_47",
      "id": "ch02-fn-47"
    }
  }, [_vm._v("47")])]), _vm._v(" Conrady, pp. 241-2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_48",
      "id": "ch02-fn-48"
    }
  }, [_vm._v("48")])]), _vm._v(" AN: LH 1121/44. Charles Etienne Philippe Gerbet was born on 6 November 1791 and was admitted to the Ecole Militaire on 20 April 1809, before he graduated as sub-lieutenant in the 37th Regiment of Line Infantry on 9 November 1812. He was discharged on 1 September 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_49",
      "id": "ch02-fn-49"
    }
  }, [_vm._v("49")])]), _vm._v(" Philippe Gerbet, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs d’un officier sur la campagne de Belgique en 1815")]), _vm._v(", Émile Javal, Arbois, 1866, pp. 8-9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_50",
      "id": "ch02-fn-50"
    }
  }, [_vm._v("50")])]), _vm._v(" Anon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoires pour servir a l’Histoire de France")]), _vm._v(", Richard Phillips & Co, London, 1820, p. 74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_51",
      "id": "ch02-fn-51"
    }
  }, [_vm._v("51")])]), _vm._v(" Emmanuel Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation de la campagne de 1815")]), _vm._v(", n.d, p. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_52",
      "id": "ch02-fn-52"
    }
  }, [_vm._v("52")])]), _vm._v(" Emmanuel Grouchy, George Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mémoires du maréchal de Grouchy")]), _vm._v(" (Vol. 4), E. Dentu, 1873, p. 126.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_53",
      "id": "ch02-fn-53"
    }
  }, [_vm._v("53")])]), _vm._v(" Damitz, Vol. 1. p. 92. See also: Wagner, Vol. 4, p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_54",
      "id": "ch02-fn-54"
    }
  }, [_vm._v("54")])]), _vm._v(" Fleury, p. 237.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_55",
      "id": "ch02-fn-55"
    }
  }, [_vm._v("55")])]), _vm._v(" Fleury, p. 237.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_56",
      "id": "ch02-fn-56"
    }
  }, [_vm._v("56")])]), _vm._v(" SHDDT: C15 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Registre d’ordre et de correspondance du major-general a partir du 13 Juin jusqu’au 26 Juin au Marechal Grouchy")]), _vm._v(", p. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_57",
      "id": "ch02-fn-57"
    }
  }, [_vm._v("57")])]), _vm._v(" Aubry, p. 150.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_58",
      "id": "ch02-fn-58"
    }
  }, [_vm._v("58")])]), _vm._v(" Jean-Roch Coignet, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Narrative of Captain Coignet Soldier of the Empire, 1776-1850")]), _vm._v(", Chatto & Windus, London, 1897, pp. 278-9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_59",
      "id": "ch02-fn-59"
    }
  }, [_vm._v("59")])]), _vm._v(" Pierre de Wit, personal communication, 14 July 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_60",
      "id": "ch02-fn-60"
    }
  }, [_vm._v("60")])]), _vm._v(" Marie Élli Guillaume de Baudus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Études sur Napoléon")]), _vm._v(", Debecourt, Paris, 1841.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_61",
      "id": "ch02-fn-61"
    }
  }, [_vm._v("61")])]), _vm._v(" Anon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoires pour servir a l’Histoire,")]), _vm._v(" pp. 77-8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_62",
      "id": "ch02-fn-62"
    }
  }, [_vm._v("62")])]), _vm._v(" Anon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoires pour servir a l’Histoire,")]), _vm._v(" p. 74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_63",
      "id": "ch02-fn-63"
    }
  }, [_vm._v("63")])]), _vm._v(" Neff, p. 23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_64",
      "id": "ch02-fn-64"
    }
  }, [_vm._v("64")])]), _vm._v(" Charles Paris Nicholas Beauvais, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoires, conquêtes, désastres, revers et guerres civils des Français, de 1792 à 1815")]), _vm._v(", C. L. F. Panckoucke, Paris, 1821, Vol. 24, p. 178. See also: SHDDT: C15 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_65",
      "id": "ch02-fn-65"
    }
  }, [_vm._v("65")])]), _vm._v(" Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation de la campagne de 1815")]), _vm._v(", p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_66",
      "id": "ch02-fn-66"
    }
  }, [_vm._v("66")])]), _vm._v(" Damitz, p. 90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_67",
      "id": "ch02-fn-67"
    }
  }, [_vm._v("67")])]), _vm._v(" Damitz, Vol. 1, p. 90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_68",
      "id": "ch02-fn-68"
    }
  }, [_vm._v("68")])]), _vm._v(" SHDDT: C15 5. Dossier 18 June 1815."), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rapport Colonel Blocqueville")]), _vm._v(". See also: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Declaration du Colonel de Bloqueville’")]), _vm._v(" in Emmanuel Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation succincte de la campagne de 1815 en Belgique,")]), _vm._v(" Delanchy, Paris, 1843.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "id": "ch02-fn-69"
    }
  }, [_vm._v("69")])]), _vm._v(" Pierre Berthezène, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs militaires de la republique et de l’empire")]), _vm._v(", J. Dumaine, Paris, 1855, pp. 360-1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_70",
      "id": "ch02-fn-70"
    }
  }, [_vm._v("70")])]), _vm._v(" Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation de la campagne de 1815")]), _vm._v(", p. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_71",
      "id": "ch02-fn-71"
    }
  }, [_vm._v("71")])]), _vm._v(" Gourgaud, p. 50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_72",
      "id": "ch02-fn-72"
    }
  }, [_vm._v("72")])]), _vm._v(" Damitz, Vol. 1, p. 91.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_73",
      "id": "ch02-fn-73"
    }
  }, [_vm._v("73")])]), _vm._v(" Gustave de Pontécoulant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs militaires: Napoleón à Waterloo")]), _vm._v(", J. Dumaine, Paris, 1866, p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_74",
      "id": "ch02-fn-74"
    }
  }, [_vm._v("74")])]), _vm._v(" Pontécoulant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Souvenirs militaires,")]), _vm._v(" p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_75",
      "id": "ch02-fn-75"
    }
  }, [_vm._v("75")])]), _vm._v(" SHDDT: GR 20 YC 137.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_76",
      "id": "ch02-fn-76"
    }
  }, [_vm._v("76")])]), _vm._v(" ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_77",
      "id": "ch02-fn-77"
    }
  }, [_vm._v("77")])]), _vm._v(" Jean Baptiste Alexandre Stroltz was born at Belfort on 6 August 1771 and was admitted into the army on 8 April 1793, before being promoted to sub-lieutenant of the 16th Chasseurs à Cheval on 22 September 1794. He is listed as aide-de-camp to General Kléber in 1795, and in this capacity he was promoted to lieutenant on 25 December 1796, to captain on 23 June 1798, to squadron commander on 10 February 1800 and then named as aide-de-camp to General Moreau. He became a colonel of the light horse regiment of the Kingdom of Naples on 25 July 1806 and was promoted to brigadier-general in the Kingdom of Naples on 30 October 1807. Stroltz commanded an infantry brigade under General Mathieu in the Sicily campaign. He was then appointed as aide-de-camp to Joseph Bonaparte, and then promoted to general-of-division on 1 July 1813. He died in Paris on 27 October 1841.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_78",
      "id": "ch02-fn-78"
    }
  }, [_vm._v("78")])]), _vm._v(" André Burthe was born in Metz in France on 8 December 1772, allegedly into a family of Irish refugees who had followed King James II of England to France. He entered military service on 6 April 1791 at the age of nineteen as a simple cavalier in the 2nd Regiment of Dragoons, after which his career had a meteoric rise. He served in the Armée du Rhine 1794-1795 and entered the general staff as an adjutant-general to Solignac in the Armée d’Italie in February 1796. In 1797, he was promoted to capitaine-d’Etat-major to the army in Italy and in October the following year became first aide-de-camp to André Masséna in the Armée d’Helvétie. He took part in the campaign in the Helvetic Republic and was promoted to Chef d’Escadron in the field at the First Battle of Zurich in 1799. He was seriously wounded twice by musket balls at the Siege of Genoa (1800). Masséna, recognising the young man’s merit, honoured him with a particular friendship and charged him, once he was recovered, with the formal presentation of the Italian enemy flags captured at the Battle of Marengo on 14 June 1800 to the new First Consul of France (Napoléon Bonaparte, following a coup the previous year). The general raised him to the rank of adjutant-general, a promotion confirmed on 14 July 1800 when the presentation took place at a public display on the Champ de Mars in Paris: an address was made by Lannes and Burthe also made a speech. On the Bourbon Restoration, Burthe retired from military service; on 6 January 1825, he was granted a pension of 4,000 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("francs")]), _vm._v(". He died on 2 April 1830.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_79",
      "id": "ch02-fn-79"
    }
  }, [_vm._v("79")])]), _vm._v(" AN: LH 2725/17. Henri Catherine Balthazard Vincent was born on 22 May 1775 and was made a Commander of the Legion of Honour on 11 August 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_80",
      "id": "ch02-fn-80"
    }
  }, [_vm._v("80")])]), _vm._v(" Pierre Bonnemains was born 13 September 1773 and was admitted to the National Guard aged eighteen. He passed to the 12th Dragoons on 20 May 1793 with the rank of sublieutenant, and then named as aide-de-camp to General Tilly in 1797. He was promoted to squadron-commander on 21 April 1800, and to major of 16th Chasseurs à Cheval on 28 October 1803, before becoming colonel of 5th Chasseurs à Cheval on 20 September 1806. He was promoted to general-de-brigade on 6 August 1811. He served in the 1823 campaign. He and Armand de Bricqueville were noted for being ardent Bonapartists in the revolution of 1830. He served in Algeria in 1839 to 1848 and died on 9 November 1850.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_81",
      "id": "ch02-fn-81"
    }
  }, [_vm._v("81")])]), _vm._v(" ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_82",
      "id": "ch02-fn-82"
    }
  }, [_vm._v("82")])]), _vm._v(" SHDDT: C15 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_83",
      "id": "ch02-fn-83"
    }
  }, [_vm._v("83")])]), _vm._v(" Berton, p. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_84",
      "id": "ch02-fn-84"
    }
  }, [_vm._v("84")])]), _vm._v(" SHDDT: C15 5. Dossier 16 June 1815. Report from General Excelmans to Grouchy 16 June 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_85",
      "id": "ch02-fn-85"
    }
  }, [_vm._v("85")])]), _vm._v(" Jean Baptiste Berton was born on 15 June 1769 at Euilly in the Ardennes. He was admitted to the military school at Brienne aged twenty-seven and then passed to the artillery school at Chalons in 1793. He was attached to the staff of Bernadotte, and served at Austerlitz and Jena, and was with Victor’s staff at Friedland, before serving in Spain with Soult’s staff from 1808 to 1814. He never took a field command until 1815, nor had any experience as a regimental colonel. On leave from July 1815, he agitated against the Bourbons and was executed for treason on 5 October 1822.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_86",
      "id": "ch02-fn-86"
    }
  }, [_vm._v("86")])]), _vm._v(" Berton, p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_87",
      "id": "ch02-fn-87"
    }
  }, [_vm._v("87")])]), _vm._v(" Coignet, p. 280.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_88",
      "id": "ch02-fn-88"
    }
  }, [_vm._v("88")])]), _vm._v(" Fleury, p. 237.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_89",
      "id": "ch02-fn-89"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("’Breife eines Preussischen Offiziers uber den Feldzug’")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Militar Wochenblatt,")]), _vm._v(" Berlin, 1822, p. 462.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_90",
      "id": "ch02-fn-90"
    }
  }, [_vm._v("90")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June 1815, Grouchy to Napoléon dated 15 June 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_91",
      "id": "ch02-fn-91"
    }
  }, [_vm._v("91")])]), _vm._v(" Louis Pierre Aimé Chastel was born on 29 April 1774. He first joined up in 1792, in the Légion des Allobroges, under the name of Jacques François Dugommier, and was then transferred to the Armée des Pyrénées and saw service in Italy. He took part in Bonaparte campaign in Egypt, where he discovered the Dendera Zodiac. He was made major-en-second (lieutenantcolonel) of the grenadiers à cheval of the Imperial Guard in 1803, and his actions at Austerlitz got him recognised by Napoléon. In 1812 he was summoned to join the French invasion of Russia, where he led the 3rd Light Cavalry Division in the 3rd Cavalry Corps. His bravery at Borodino gained him a mention in dispatches. He died on 26 September 1826 in Geneva.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_92",
      "id": "ch02-fn-92"
    }
  }, [_vm._v("92")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June. Report from General Excelmans to Grouchy 16 June 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_93",
      "id": "ch02-fn-93"
    }
  }, [_vm._v("93")])]), _vm._v(" AN: LH 1227/40. Armand de Bricqueville was born at Bretteville in 1785 and was listed as a sub-lieutenant of the 18th Dragoons in 1803, as a major of the 2nd Light Horse Lancers of the Imperial Guard in 1813, and named as a colonel of 20th Dragoons during the Hundred Days.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_94",
      "id": "ch02-fn-94"
    }
  }, [_vm._v("94")])]), _vm._v(" AN: LH 1227/40. Marie Jacques Emmanuel Guibourg was born on 15 December 1775.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_95",
      "id": "ch02-fn-95"
    }
  }, [_vm._v("95")])]), _vm._v(" AN: LH 963/46. Jean Louis Ferroussat was born in London on 3 July 1780 and was admitted to the 9th Dragoons on 2 January 1797, before being promoted to corporal on 14 November 1798, to sergeant on 3 June 1800, to sous-lieutenant on 19 September 1801, to lieutenant on 7 January 1804, and to captain on 27 February 1806. He was named as the ADC to General Monpetit on 27 June 1806, and promoted to squadron commander on 17 September 1811. He was listed as major of 10th Chasseurs à Cheval on 18 July 1813, as colonel on 3 April 1814 and as chief-ofstaff to 2nd Cavalry Corps on 15 May 1815. He was then listed as colonel of the 2nd Lancers in place of Colonel Sourd on 3 July 1815, before being discharged on 22 September 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_96",
      "id": "ch02-fn-96"
    }
  }, [_vm._v("96")])]), _vm._v(" AN: LH 771/50. Jean Baptiste William Dibon was born on 8 April 1793 and admitted to the Military School at Saint-Germain on 11 November 1812, before being named as sublieutenant in the Chasseurs à Cheval of the Young Guard on 19 February 1814, and admitted to the 1st Cuirassiers on 10 July 1814. He was promoted to lieutenant on 23 March 1815 and became aide-de-camp to Excelmans on 27 June 1815, before being dismissed on 22 June 1819.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_97",
      "id": "ch02-fn-97"
    }
  }, [_vm._v("97")])]), _vm._v(" SHDDT: C15 5. Dossier 15 June. Pajol to Grouchy 15 June 1815, timed at 22.00.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_98",
      "id": "ch02-fn-98"
    }
  }, [_vm._v("98")])]), _vm._v(" Sénécal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("General le Sénécal campagne de Waterloo")]), _vm._v(", Philadelphia, 1818, pp. 2-6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_99",
      "id": "ch02-fn-99"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouvel Revue Rétrospective")]), _vm._v(", January 1896, p. 366.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_100",
      "id": "ch02-fn-100"
    }
  }, [_vm._v("100")])]), _vm._v(" Napoleon I, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Correspondance de Napoleon 1er")]), _vm._v(", vol.28, H. Plon, J. Dumaine, Paris, 1858. Order No. 22056 Bulletin of the Army.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_101",
      "id": "ch02-fn-101"
    }
  }, [_vm._v("101")])]), _vm._v(" Napoleon I. Order No. 22055 to Prince Joseph 15 June 1815, timed as 21.00.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_102",
      "id": "ch02-fn-102"
    }
  }, [_vm._v("102")])]), _vm._v(" Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Relation succincte de la campagne de 1815")]), _vm._v(", pp. 31-2. See also: Gourgaud, p. 68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_103",
      "id": "ch02-fn-103"
    }
  }, [_vm._v("103")])]), _vm._v(" Christopher Bassford, Daniel Moran, Gregory W. Pedlow, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clausewitz, Wellington and the Campaign of 1815")]), _vm._v(", On Waterloo, available at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://www.clausewitz.com/readings/1815/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.clausewitz.com/readings/1815/")])])]), _vm._v(" TOC.htm [accessed 12 April 2012].")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_104",
      "id": "ch02-fn-104"
    }
  }, [_vm._v("104")])]), _vm._v(" Conrady, p. 242.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn_105",
      "id": "ch02-fn-105"
    }
  }, [_vm._v("105")])]), _vm._v(" ibid.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55bf2f87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter_2.vue
// module id = 78
// module chunks = 0